const RoleEnum = {
  ONLINE: { code: 1, text: "Online" },
  OFFLINE: { code: 2, text: "Offline" },
  ERROR: { code: 3, text: "Chyba" },
  NOPLAYER: { code: 4, text: "Bez fotomatu" },
};

export default RoleEnum;
